module.exports = __webpack_public_path__ + "static/img/3161_phase_function_Paper_Points.7781ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3161_phase_function_Paper_Points.png
// module id = JqrZ
// module chunks = 0